import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { UtensilsCrossed, Heart } from "lucide-react";
import { useGuestLang, LangToggle } from "@/lib/guestI18n";

const TXT = {
  en: {
    kicker: "SEE YOU NEXT YEAR",
    title: "This year's event has ended",
    body: "Thank you to everyone who joined us and made Food Bazaar a celebration of our cultures, food and community.",
    next: "We'll be back next October!",
    note: "Voting and drink recharges are now closed.",
  },
  es: {
    kicker: "¡NOS VEMOS EL PRÓXIMO AÑO!",
    title: "El evento de este año ha terminado",
    body: "Gracias a todos los que nos acompañaron e hicieron de Food Bazaar una celebración de nuestras culturas, comida y comunidad.",
    next: "¡Regresamos el próximo octubre!",
    note: "La votación y las recargas de bebidas están cerradas.",
  },
};

function EventClosed() {
  const { lang, setLang } = useGuestLang();
  const t = TXT[lang] || TXT.en;
  return (
    <div className="min-h-screen bg-[#0B1120] text-slate-100 relative overflow-hidden" data-testid="event-closed-page">
      <LangToggle lang={lang} setLang={setLang} />
      <div className="absolute -top-24 -left-24 w-96 h-96 rounded-full bg-orange-500/20 blur-3xl" />
      <div className="absolute -bottom-24 -right-24 w-96 h-96 rounded-full bg-rose-600/20 blur-3xl" />
      <div className="relative z-10 max-w-md mx-auto px-6 py-16 flex flex-col items-center text-center animate-in fade-in slide-in-from-bottom-2">
        <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-orange-500 to-rose-500 flex items-center justify-center shadow-2xl shadow-orange-500/30 mb-4"><UtensilsCrossed className="text-white" size={30} /></div>
        <h1 className="font-display text-4xl sm:text-5xl font-black tracking-tight">FOOD BAZAAR</h1>
        <div className="mt-8 text-xs tracking-[0.3em] font-bold text-orange-400" data-testid="event-closed-kicker">{t.kicker}</div>
        <h2 className="mt-2 font-display text-2xl font-black text-white" data-testid="event-closed-title">{t.title}</h2>
        <p className="mt-4 text-slate-300 leading-relaxed">{t.body}</p>
        <div className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#131D33] border border-orange-500/40 px-5 py-2.5 font-bold text-orange-300" data-testid="event-closed-next">
          <Heart size={16} className="text-rose-400" /> {t.next}
        </div>
        <p className="mt-8 text-xs text-slate-500">{t.note}</p>
      </div>
    </div>
  );
}

export default function GuestGate({ children }) {
  const [closed, setClosed] = useState(null);
  useEffect(() => {
    api.get("/guest-portal").then((r) => setClosed(!!r.data.closed)).catch(() => setClosed(false));
  }, []);
  if (closed === null) return <div className="min-h-screen bg-[#0B1120]" />;
  return closed ? <EventClosed /> : children;
}
